<script>
  import { MarkerClusterer } from '@googlemaps/markerclusterer';

  import { ACTIVITY_EVENTS } from '@client/enums';

  export let height = 500;
  export let config = {};
  export let markers = [];
  export let center = { lat: 38.264959347360545, lng: -49.9500312347612 };
  export let zoom = 2.5;
  export let mapFilters = [];

  let container = null;
  let map;
  let clusterer;
  let infoWindow;
  let AdvancedMarkerElement;

  const loadLibraries = async () => {
    const { Map, InfoWindow } = await google.maps.importLibrary('maps');
    infoWindow = new InfoWindow();
    createMap(Map);
  };

  const getCircle = (item) => {
    const event = ACTIVITY_EVENTS[item.verb === 'clicked' || item.verb === 'visited' ? item.objecttype : item.verb];
    const scale = event.weight;
    const color = event.color;

    return {
      path: google.maps.SymbolPath.CIRCLE,
      fillColor: color,
      fillOpacity: 0.3,
      scale: Math.pow(2, scale) / 2,
      strokeWeight: item.proxy ? 2 : 1,
      strokeColor: item.proxy ? '#d52b1e' : color,
      strokeOpacity: item.proxy ? 1 : 0.3
    };
  };

  const createMap = (Map) => {
    if (!container) {
      return;
    }

    if (!map) {
      if (window.innerWidth < 1921) {
        center = { lat: 38.8097343, lng: -90.5556199 };
        zoom = 1;
      }

      map = new Map(container, {
        zoom,
        center,
        // Wheel zoom stays off (see `scrollwheel` below), so the buttons are the only way to
        // zoom. Set explicitly rather than relying on the default: an explicit control also
        // survives the API's rule of hiding default controls on maps under 200x200px.
        // `cameraControl` is the newer combined zoom+pan control — off so we don't render two.
        cameraControl: false,
        zoomControl: true,
        ...config,
        scrollwheel: false,
        mapId: 'be4deb1c5a134a6d'
      });
    }

    if (!clusterer) {
      clusterer = new MarkerClusterer({ map });
    }

    clusterer.clearMarkers();

    const filteredMarkers = markers
      .filter((item) => {
        const event = item.verb === 'clicked' || item.verb === 'visited' ? item.objecttype : item.verb;
        return mapFilters.includes(event);
      })
      .map((item) => {
        const marker = new google.maps.Marker({
          position: item.position,
          icon: getCircle(item),
          optimized: true
        });

        marker.addListener('click', () => {
          infoWindow.close();
          infoWindow.setContent(item.content);
          infoWindow.open(map, marker);
        });

        return marker;
      });

    clusterer.addMarkers(filteredMarkers);
  };

  $: markers && loadLibraries();
  $: mapFilters && loadLibraries();
</script>

<div class="map" bind:this={container} style="height: {height}px;" />

<style lang="scss" src="./map.scss"></style>
